// extracted by mini-css-extract-plugin
export default {"wrap":"Wr-z","melodyCategory":"Xr-z","fullWidth":"Yr-z","items":"Zr-z","featureCss":"_r-z","disabled":"as-z","imgCss":"bs-z"};